/**
 * 安全打开外链(T-01-03-01 Open Redirect mitigation):
 * 1. url 为空/undefined/null → 返回 false,不跳转(fail-safe)
 * 2. 仅允许 http/https scheme(防 javascript:/file:/data: 协议注入)
 * 3. 走 `window.open(url, target, 'noopener,noreferrer')` 防 opener 劫持
 *
 * 位置决策:本期 D-02 先落 `@ark/mets-frontend-shared` 共享包。
 * 无业务 deps,Phase 3 FLASH-01 / MATCH-02 可直接复用。
 *
 * @returns true 表示校验通过且已调用 window.open;false 表示被拦截。
 */
export function safeOpen(
  url: string | undefined | null,
  target: string = '_blank',
): boolean {
  if (url == null) return false;
  const trimmed = String(url).trim();
  if (trimmed.length === 0) return false;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return false;
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }

  window.open(trimmed, target, 'noopener,noreferrer');
  return true;
}
